<template>
<!-- MySQL은 데몬프로세스와 DB 세션 동일한 컴포넌트 사용 -->
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
    <w-header-search-button @click="onSearchButtonClick"></w-header-search-button>
  </el-row>
  <el-table-wrapper v-loading="isLoading" :data="tableData" :columns="columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    <template slot-scope="scope" slot="sql-slot">
      <i v-show="scope.row.INFO" class="far fa-search-plus c-pointer" @click="showSqlDetailPopup(scope.row.INFO)" />
    </template>
  </el-table-wrapper>
  <!-- <w-dbsession-sql-query-show-popup ref="sqlDetailPopup" /> -->
  <w-sliding-popup ref="slidingPopup" title="상세보기" width="600px" @close="onSqlDetailPopupClose">
    <div slot="content">
      <div class="title-bar title-h4">SQL문</div>
      <el-input type="textarea" :autosize="{ minRows: 6 }" readonly v-model="selectedSqlText"></el-input>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import { analysisTimeType } from '@/constants/performance';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WDbsessionSqlQueryShowPopup from '@/views/performance/node/analysis/database/popup/DbsessionSqlQueryShowPopup';

export default {
  name: 'WDemonprocessMysqlTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
    WDbsessionSqlQueryShowPopup,
  },
  data() {
    return {
      isLoading: false,
      checkDatetime: null,
      columnDefault,
      tableData: [],
      showSearchTool: false,
      parameterMap: {},
      selectedSqlText: '',
      columns: [
        {
          prop: 'ID',
          label: 'PID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'USER',
          label: '사용자',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'TERMINAL',
          label: '터미널',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'HOST',
          label: '호스트',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'DB',
          label: 'DB명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'COMMAND',
          label: '수행 명령',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'TIME',
          label: 'Sleep 시간(초)',
          sortable: true,
          formatter: this.convertValue,
        },
        {
          prop: 'STATE',
          label: '상태',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'INFO',
          label: '수행 Query문',
          headerAlign: 'center',
          align: 'center',
          width: '120px',
          sortable: true,
          searchable: true,
          scopedSlot: 'sql-slot',
        },
      ],
    };
  },
  methods: {
    isNil,
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? new Date().getTime() : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.queryId = 'DBMYLockInfo';
        params.parameterMap = {
          orderby: 'ID',
        };
        this.isLoading = true;
        databaseTableInfoAPI.getCurrentDbsessionList(params).then((result) => {
          if (result.data.success === true) {
            this.tableData = result.data.data;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = true;
        databaseTableInfoAPI.getDemonprocessDbsessionMysqlList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    failToLoadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 헤더 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onSearchButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * SQL문 상세 팝업을 연다.
     * @author Ju
     * @param  {[type]} row 세션 정보
     */
    showSqlDetailPopup(row) {
      this.selectedSqlText = row;
      this.$refs.slidingPopup.open();
    },
    onSqlDetailPopupClose() {
      this.selectedSqlText = '';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DemonProcess/DemonprocessMysqlTable.vue